import { ApiUrl } from '@common/enums';
import { StoreModel } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';

export type CfiCompany = Omit<StoreModel, 'adPatchId'>;

export type CfiCompanyQueryParams = {
    params?: {
        address?: string;
        city?: string;
        state?: string;
        zipCode?: string;
        prodQteGrpID: number;
        storeId: number;
    };
};

const cfisApi = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchCfis: builder.query<CfiCompany[], CfiCompanyQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.CFIS_URL,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchCfisQuery } = cfisApi;
